export const replaceNullToEmpty = (obj) => {
  return Object.entries(obj).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value === null ? "" : value }),
    {}
  );
};
